import script from "./StaffShift2.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffShift2.vue?vue&type=script&setup=true&lang=js"

import "./StaffShift2.vue?vue&type=style&index=0&id=59f85b1e&lang=scss"

const __exports__ = script;

export default __exports__